
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    display: block
}

.review-quote__footer {

    margin-bottom: 2rem;

    margin-left: 2.5rem;

    display: flex;

    justify-content: space-between;

    border-width: 1px;

    border-top-width: 1px;

    border-bottom-width: 0px;

    border-left-width: 0px;

    border-right-width: 0px;

    border-style: solid;

    border-color: var(--neutral-gray-4);

    padding-top: 1rem
}

@media (min-width: 768px) {

    .review-quote__footer {

        margin-left: 70px
    }
}

.review-quote__date {

    font-size: var(--fs-sm);

    line-height: var(--lh-sm);

    font-weight: var(--fw-semibold);

    color: var(--neutral-gray-1)
}

@media (min-width: 768px) {

    .review-quote__date {

        font-size: var(--fs-base);

        line-height: var(--lh-base)
    }
}

.review-quote ghs-quote-testimonial {

    margin-bottom: 1.25rem
}
`;